import { render, staticRenderFns } from "./HistoryDialogV2.vue?vue&type=template&id=4f481016&scoped=true&"
import script from "./HistoryDialogV2.vue?vue&type=script&lang=js&"
export * from "./HistoryDialogV2.vue?vue&type=script&lang=js&"
import style0 from "./HistoryDialogV2.vue?vue&type=style&index=0&id=4f481016&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f481016",
  null
  
)

export default component.exports